function UpArrowsIcon() {
  return (
    <svg
      width="17"
      height="16"
      viewBox="0 0 17 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_63067_38719)">
        <path
          d="M2.5 11.3327L6.5 7.33268L9.16667 9.99935L14.5 4.66602"
          stroke="#02542D"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M9.83301 4.66602H14.4997V9.33268"
          stroke="#02542D"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_63067_38719">
          <rect
            width="16"
            height="16"
            fill="white"
            transform="translate(0.5)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}

export default UpArrowsIcon;
